import Tooltip from "@ui-components/Tooltip";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import useMediaQuery from '../../hooks/useMediaQuery';


function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const MenuLink = ({
    name, href, Icon, clickable = true, onTouchEnd = () => {}
}) => {
    const { pathname } = useLocation();
    const active = pathname.indexOf(href) >= 0;
    const isMobile = useMediaQuery('(max-width: 1024px)');

    return (
        <>
            {clickable || isMobile ? (
                <Link
                    key={name}
                    to={href}
                    className={classNames(
                        active
                            ? "bg-grey-20 shadow-md item-center truncate text-black border border-transparent"
                            : "text-black truncate border border-transparent",
                        "flex items-center px-3 py-3 hover:text-black hover:border-gray-100 hover:shadow-md font-medium rounded-3xl"
                    )}
                    onTouchEnd={() => onTouchEnd()}
                >
                    <Icon
                        className={classNames(
                            active ? "text-black" : "text-black",
                            "mr-4 h-6 w-6"
                        )}
                        aria-hidden="true"
                    />
                    {name}
                </Link>
            ) : (
                <div
                    className={classNames(active ? " bg-grey-20 flex justify-center shadow-md" : "flex item-center justify-center",
                        "h-[48px] w-[48px] group flex items-center text-base font-medium rounded-3xl"
                        ,"hover:border hover:border-gray-20 hover:shadow-md"
                        )
                        }>
                    <Tooltip text={name} placement="right">
                        <Link
                            key={name}
                            to={href}
                            className={"text-black hover:text-black"}>
                            <Icon
                                className={classNames(active ? "bg-gray-20 flex justify-center" : "",
                                    "h-[24px] w-[24px]")}
                                aria-hidden="true"
                            />
                        </Link>
                    </Tooltip>
                </div>
            )}
        </>
    );
};

export default MenuLink;
